import { render, staticRenderFns } from "./origem-voo.vue?vue&type=template&id=3489010d"
import script from "./origem-voo.vue?vue&type=script&lang=js"
export * from "./origem-voo.vue?vue&type=script&lang=js"
import style0 from "./origem-voo.vue?vue&type=style&index=0&id=3489010d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports